<template>
    <main>
        <section class="hero">
            <div class="lg:tw-container tw-flex tw-flex-col lg:tw-flex-row lg:tw-justify-between lg:tw-gap-5">
                <div class="info tw-px-5 lg:tw-px-0 lg:tw-pt-12">
                    <img src="~@/assets/img/logo.svg" alt="logo" class="logo tw-pointer-events-none">
                    <h2>Formação Gratuita</h2>
                    <h1>
                        Receba o melhor acompanhamento para os seus investimentos
                    </h1>
                    <ul>
                        <li>
                            <img src="~@/assets/img/icons/bullet.svg">
                            <span>Formação gratuita pela Deco Proteste Investe</span>
                        </li>
                        <li>
                            <img src="~@/assets/img/icons/bullet.svg">
                            <span>ETFs, ações e acompanhamento especializado</span>
                        </li>
                        <li>
                            <img src="~@/assets/img/icons/bullet.svg">
                            <span>ETFs, ações e acompanhamento especializado</span>
                        </li>
                    </ul>
                </div>
                <div class="tw-w-full">
                    <Form v-if="!$store.state.formSuccess"/>
                    <FormSuccess v-if="$store.state.formSuccess"/>
                </div>
            </div>
        </section>

        <section class="products">
            <div class="tw-container tw-text-center tw-py-10 lg:tw-px-24">
                <h3 class="tw-uppercase tw-text-xl tw-font-bold tw-mb-4">Todos os produtos a partir de uma única conta</h3>
                <h2 class="tw-italic tw-text-xl lg:tw-text-3xl tw-text-blue-500 tw-font-light tw-mb-16">A Invest BTrader oferece plataformas de trading com produtos para todos os investidores.</h2>

                <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-20">
                    <div class="bullet">
                        <img src="~@/assets/img/icons/access.svg" alt="Acesso Direto">
                        <h4>ACESSO DIRECTO</h4>
                        <p>À Sala de Mercados</p>
                    </div>
                    <div class="bullet">
                        <img src="~@/assets/img/icons/commissions.svg" alt="Acesso Direto">
                        <h4>O% COMISSÃO</h4>
                        <p>Manutenção de Conta, Guarda de Títulos
                            e Dividendos</p>
                    </div>
                    <div class="bullet">
                        <img src="~@/assets/img/icons/webinar.svg" alt="Acesso Direto">
                        <h4>WEBINÁRIOS E CURSOS EXCLUSIVOS</h4>
                        <p>Para acompanhamento dos mercados em directo e promover a literacia financeira</p>
                    </div>
                    <div class="bullet">
                        <img src="~@/assets/img/icons/course.svg" alt="Acesso Direto">
                        <h4>CURSO EXCLUSIVO</h4>
                        <p>Formação Certificada Deco Proteste Investe</p>
                    </div>
                    <div class="bullet">
                        <img src="~@/assets/img/icons/offer.svg" alt="Acesso Direto">
                        <h4>MAIOR OFERTA</h4>
                        <p>Em Acções, ETF's, CFD's, Forex, Matérias Primas, Futuros e Opções</p>
                    </div>
                    <div class="bullet">
                        <img src="~@/assets/img/icons/internacional.svg" alt="Acesso Direto">
                        <h4>MERCADOS INTERNACIONAIS</h4>
                        <p>Mais de 170 mercados a partir de uma única conta, 24h por dia</p>
                    </div>
                </div>
            </div>
        </section>

        <section class="risk">
            <div class="tw-container tw-flex tw-flex-col lg:tw-flex-row tw-gap-5">
                <div>
                    <h3 class="font-bold text-base mb-2.5 uppercase">ADVERTÊNCIAS ESPECÍFICAS AO INVESTIDOR</h3>
                    <p>Esta comunicação tem natureza informativa e promocional. A informação aqui apresentada não dispensa a consulta da informação pré-contratual disponibilizada para cada produto financeiro, <a href="https://www.bancoinvest.pt/btrader/Plataforma-de-Trading-Online" target="_blank"><u>https://www.bancoinvest.pt/btrader/Plataforma-de-Trading-Online</u></a> antes de tomar qualquer decisão de investimento.</p>
                    <p>A apresentação dos produtos e serviços nesta comunicação não implica que sejam adequados ao seu perfil de risco, experiência e conhecimentos, situação financeira ou objetivos de investimento. Antes de tomar qualquer decisão de investimento, avalie cuidadosamente as características, riscos e condições dos produtos ou serviços em causa.</p>
                    <p>Os investimentos em instrumentos financeiros envolvem riscos, incluindo o risco de perda parcial ou total do capital investido. O valor dos investimentos e os rendimentos deles decorrentes podem variar ao longo do tempo. O desempenho passado não constitui garantia de resultados futuros. Os produtos financeiros complexos apresentam características e riscos específicos que podem ser difíceis de compreender, e poderão não ser adequados para todos os investidores.</p>
                    <p><b>Advertência relativa a CFD:</b> Os CFD são instrumentos complexos e apresentam um elevado risco de perda rápida de dinheiro devido ao efeito de alavancagem. Entre 58,9% e 76,0% das contas de investidores de retalho perdem dinheiro quando negoceiam CFD com estes fornecedores. Deve considerar se compreende como funcionam os CFD e se pode correr o elevado risco de perda do seu dinheiro. A negociação de CFD pode não ser adequada a todos os investidores. Antes de negociar, deve assegurar‑se de que compreende plenamente os riscos associados a estes instrumentos financeiros.</p>
                </div>
            </div>
        </section>

        <footer class="tw-pt-10 tw-pb-5">
            <div>
                <div class="tw-container tw-flex tw-flex-col tw-justify-center tw-items-center tw-px-5 lg:tw-px-0">
                    <img src="@/assets/img/logo_footer_black.svg">
                    <small class="tw-text-center tw-block">
                        O Banco Invest S.A., é uma instituição registada no Banco de Portugal com o código 0014 e na Comissão de Mercado e Valores Mobiliários sob o n° 0141.<br><br>
                        © {{ new Date().getFullYear() }} BANCO INVEST - TODOS OS DIREITOS RESERVADOS
                    </small>
                </div>
            </div>
        </footer>
    </main>
</template>
<script>
import Form from '@/components/FormNew.vue';
import FormSuccess from '@/components/FormSuccess.vue';

export default {
    name: 'Home',
    components: {
        Form,
        FormSuccess,
    },
    mounted() {
        // Isto foi tudo a chatGPT lol:
        const parentStyling = `
            position: relative !important;
            overflow: hidden !important;
            pointer-events: none !important;
            -ms-overflow-style: none;
            scrollbar-width: none;
            width: calc(100% + 30px);
            height: 46px;
            max-height: 46px;
            right: -30px !important;
            left: 0;
          `;
        const iframeStyling = `
            pointer-events: none !important;
            width: 100%;
            height: 46px;
            max-height: 46px;
            border: 0 !important;
            display: block !important;
          `;

        const tryMoveWidget = () => {
            const iframe = document.querySelector('iframe[src*="tradingview"]');
            const container = document.querySelector('.iframe-container');

            if (!iframe || !container) {
                setTimeout(tryMoveWidget, 100);
                return;
            }

            // 🔑 em vez de mover só o iframe, move o wrapper que o TradingView cria
            const widgetRoot = iframe.closest('.tradingview-widget-container')
                || iframe.parentElement;

            container.appendChild(widgetRoot);

            // aplica os estilos “parent” ao wrapper
            widgetRoot.setAttribute('style', parentStyling);

            // aplica os estilos ao iframe
            iframe.setAttribute('style', iframeStyling);

            // evita backgrounds brancos inesperados
            widgetRoot.style.background = 'transparent';
            iframe.style.background = 'transparent';
        };

        tryMoveWidget();
    },

};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/variables';

section.hero {
    @apply tw-py-5;

    background-image: url('~@/assets/img/hero-new.jpg');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;

    @screen lg {
        @apply tw-py-32;
    }

    .info {
        .logo {
            width: 160px;
            margin-bottom: 50px;

            @screen lg {
                width: 280px;
                margin-bottom: 50px;
            }
        }

        h2 {
            @apply tw-text-white tw-font-bold tw-text-base tw-uppercase tw-px-4 tw-py-2 tw-leading-none tw-mb-4;

            width: fit-content;
            background-color: #009DE0;
        }

        h1 {
            @apply tw-text-white tw-font-bold tw-text-2xl;

            @screen lg {
                @apply tw-text-5xl tw-mb-12;
            }
        }

        ul {
            @apply tw-hidden;

            @screen lg {
                @apply tw-block;
            }

            li {
                @apply tw-flex tw-items-center tw-gap-3 tw-font-bold tw-text-white tw-text-xl tw-mb-6;

                > img {
                    @apply tw-pointer-events-none;
                }
            }
        }
    }
}

section.products{
    .bullet{
        img{
            @apply tw-mx-auto tw-mb-4;

            max-width: 65px;
        }
        h4{
            @apply tw-font-bold tw-text-sm tw-mb-2;

            color: #009DE0;
        }
        p{
            @apply tw-text-sm;
        }
    }
}

section.risk{
    @apply  tw-text-white tw-py-8;

    background-color: #0E273A;

    @screen lg {
        @apply tw-py-16
    }

    img{
        @apply tw-w-full tw-max-w-sm tw-mx-auto tw-h-auto tw-block tw-object-contain;

        @screen lg {
            @apply tw-mb-0;
        }
    }
    p{
        @apply tw-text-xs tw-leading-snug tw-mb-4;
    }
}

footer {
    img {
        width: 178.06px;
    }

    small {
        font-size: 10px;
        padding: 15px 0;

        @screen lg {
            font-size: 10px;
            padding: 20px 0;
        }
    }
}

</style>
